export default "__VITE_ASSET__CVecRroh__"